<template>
  <div class="content-right">
    <div class="content-wrapper container-xxl p-0">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <div class="body-content-overlay"></div>
        <!-- Main contact area -->
        <section class="chat-app-window">
          <!-- To load Conversation -->
          <div class="start-chat-area d-none">
            <div class="mb-1 start-chat-icon">
              <i data-feather="message-square"></i>
            </div>
            <h4 class="sidebar-toggle start-chat-text">Select Contact</h4>
          </div>
          <!--/ To load Conversation -->

          <!-- Active Contact -->
          <div class="active-chat">
            <!-- Contact Header -->
            <div class="chat-navbar">
              <header class="chat-header">
                <div class="d-flex align-items-center">
                  <div @click="$emit('sidebarActiveInactive')" class="sidebar-toggle d-block d-lg-none me-1">
                    <i class="fa fa-bars"></i>
                  </div>
                  <div class="avatar avatar-border user-profile-toggle m-0 me-1">
                    <img :src="contactInfo.photo" width="42" class="border-0" :alt="contactInfo.full_name"/>
                  </div>
                  <h6 class="mb-0">
                    {{ contactInfo.full_name }}<br>
                    <small v-for="profile_item in contactInfo.profile_items">
                      {{ profile_item.value }}<br>
                    </small>
                  </h6>
                </div>
                <div class="d-flex align-items-center me-md-3 me-lg-3">
                  <div class="mx-1" @click="$emit('handleEdit', contactInfo)" >
                    <h5 role="button" class="btn btn-dark">Profile</h5>
                  </div>
                  <button :disabled="loading" class="btn btn-outline-secondary" @click="onClickToPrint">
                     Print
                  </button>
                </div>

              </header>
            </div>
            <!--/ Contact Header -->

            <!-- User Chat messages -->
            <div class="user-chats">
              <div class="chats">
                <ul class="nav nav-tabs">
                  <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <a
                        :href="`#${tab.id}`"
                        :class="['nav-link', { active: activeTabId === tab.id }]"
                        @click="setActiveTab(tab)"
                    >
                      {{ tab.title }}
                    </a>
                  </li>
                </ul>
                <component :is="activeTab" :contactDetails="contactDetails" :contactInfo="contactInfo"/>
              </div>
            </div>
            <!-- User Contact messages -->
          </div>
          <!--/ Active Contact -->
        </section>
        <!--/ Main contact area -->
      </div>
    </div>
  </div>
</template>

<script setup>
import EmployeeOffBoarding from "@/views/page/company/hr-payroll/employee-register/register/tabs/EmployeeOffBoarding.vue";
import Statements from "@/views/page/company/hr-payroll/employee-register/register/tabs/Statements.vue";
import Attendance from "@/views/page/company/hr-payroll/employee-register/register/tabs/Attendance.vue";
import Leave from "@/views/page/company/hr-payroll/employee-register/register/tabs/Leave.vue";
import Note from "@/views/page/company/hr-payroll/employee-register/register/tabs/Note.vue";
import Payslip from "@/views/page/company/hr-payroll/employee-register/register/tabs/Payslip.vue";
import ProvidentFund from "@/views/page/company/hr-payroll/employee-register/register/tabs/ProvidentFund.vue";
import PerformanceAppraisal from "@/views/page/company/hr-payroll/employee-register/register/tabs/PerformanceAppraisal.vue";
import Attachment from "@/components/molecule/company/hospital/patient/register/tabs/Attachment.vue";
import {ref} from "vue";
import handleCompanyContact from "@/services/modules/companyContact";
import {useRoute} from "vue-router";
import employeeProfilePdf from '@/services/utils/pdf/employeeProfilePdf';

const activeTab = ref(Attendance)
const loading = ref(false)
const route = useRoute();
const activeTabId = ref('attendance')

const props = defineProps({
  contactInfo: {
    type: Object,
    default: {
      full_name: '',
      profile_items: [],
      contact: {},
    }
  },
  contactDetails: {
    type: Array,
    default: []
  }
})

const {
  fetchSingleCompanyContact,
} = handleCompanyContact();
const { exportToPDF } = employeeProfilePdf();
const contactDetails = ref({})

const tabs = [
  {id: 'attendance', title: 'Attendance', component: Attendance},
  {id: 'leave', title: 'Leave', component: Leave},
  {id: 'employee-off-boarding', title: 'Employee Offboarding', component: EmployeeOffBoarding},
  {id: 'payslip', title: 'Payslip', component: Payslip},
  {id: 'provident-fund', title: 'Provident Fund', component: ProvidentFund},
  {id: 'performance-appraisal', title: 'Performance Appraisal', component: PerformanceAppraisal},
  {id: 'statements', title: 'Statements', component: Statements},
  {id: 'note', title: 'Note', component: Note},
  {id: 'attachment', title: 'Attachment', component: Attachment},
]

const setActiveTab = tab => {
  activeTab.value = tab.component;
  activeTabId.value = tab.id;
};

async function onClickToPrint() {
  let id = props.contactInfo.id
  loading.value = true
  let query = `?company_id=${route.params.companyId}`;
  query += "&call_from=employee&is_all_field=true";

  await fetchSingleCompanyContact(query, id).then((res) => {
    if (!res.status) {
      return
    }
    contactDetails.value = res.data;
  }).then(() => {
    exportToPDF(
        contactDetails.value
    )
  }).catch((err) => {
    console.log("Something went wrong");
  }).finally(() => {
    loading.value = false
  })
}

</script>

<style scoped>
.user-chats {
  background-image: none !important;
  overflow-y: scroll;
  height: calc(100% - 65px);
  overflow-x: hidden;
}
</style>
